<template>
        <UAnnouncement></UAnnouncement>
    <HeaderDefault></HeaderDefault>
 
    
    <section>

        
        <div class=" max-w-screen-lg px-4 pb-8 mx-auto  lg:py-10 page">
            <!-- <h2 class="text-5xl font-semibold leading-relaxed capitalize">        terms and conditions</h2> -->
        <MDC class="text text-md leading-normal my-5 text-gray-700 selection:bg-blue-700 selection:text-white markdown-body"
        :value="cond" tag="article" />
        </div>
        
    </section>
    <FooterDefault></FooterDefault>
</template>

<script setup>

let cond=`
# Terms and Conditions

Welcome to AcademicAlerts.org, a service provided by ACADNETICA SOLUTIONS PRIVATE LIMITED ("we", "our", or "us"). By using our website and services, you agree to the following terms and conditions. Please read them carefully.

## 1. Acceptance of Terms

By accessing and using AcademicAlerts.org ("the website"), you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree with these Terms, please do not use our website.

## 2. Services

AcademicAlerts.org provides users with notifications and updates on academic events, including conferences, seminars, workshops, and other academic activities. We aim to provide accurate and timely information; however, we do not guarantee the completeness or accuracy of all information provided.

## 3. User Accounts

To access certain features of our website, you may be required to create an account. You are responsible for maintaining the confidentiality of your account information, including your password, and for all activities that occur under your account.

## 4. Privacy Policy

We are committed to protecting your privacy. Please refer to our Privacy Policy for information on how we collect, use, and disclose your personal information.

### Use of Google Analytics

We use Google Analytics to track user behavior on our website. This helps us understand how users interact with our site, enabling us to improve our services. Google Analytics collects information such as the pages you visit, the time spent on each page, and the interactions you have with our site. For more information on how Google collects and processes data, please visit [Google's Privacy Policy](https://policies.google.com/privacy).

### Use of Screen-Recording Tools

For the purpose of enhancing user experience (UX), we utilize screen-recording tools that capture user interactions on our website. This includes mouse movements, clicks, and scrolling behavior. This data is used solely to improve the design and functionality of our website.

## 5. Intellectual Property

All content on AcademicAlerts.org, including text, graphics, logos, images, and software, is the property of ACADNETICA SOLUTIONS PRIVATE LIMITED or its content suppliers and is protected by intellectual property laws. Unauthorized use of any content is prohibited.

## 6. User Conduct

You agree not to use our website for any unlawful purpose or any purpose prohibited by these Terms. You are prohibited from using our website to:
- Post or transmit any false, misleading, defamatory, or offensive content.
- Violate the rights of others, including their privacy and intellectual property rights.
- Distribute viruses, malware, or any other harmful software.
- Engage in any activity that disrupts or interferes with the functioning of our website.

## 7. Limitation of Liability

ACADNETICA SOLUTIONS PRIVATE LIMITED will not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your use of our website or services. This includes, but is not limited to, any errors or omissions in the content, or any loss or damage incurred as a result of the use of our website.

## 8. Indemnification

You agree to indemnify and hold ACADNETICA SOLUTIONS PRIVATE LIMITED harmless from any claims, losses, liabilities, damages, and expenses, including legal fees, arising out of your use of our website or violation of these Terms.

## 9. Changes to Terms

We reserve the right to modify these Terms at any time. Any changes will be effective immediately upon posting on our website. Your continued use of our website following the posting of changes constitutes your acceptance of such changes.

## 10. Governing Law and Jurisdiction

These Terms are governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these Terms will be subject to the exclusive jurisdiction of the courts in India.

## 11. Contact Us

If you have any questions or concerns about these Terms, please contact us at:

**Email:** academicAlertsHQ@gmail.com

 
ACADNETICA SOLUTIONS PRIVATE LIMITED
India

Thank you for using AcademicAlerts.org.

Effective Date: 26/07/24`
</script>